module.exports = "https://r.nearpod.com/assets/media/image/stopwatch-icon-664f82369a199d5d976d61f676dfefae.svg";